import React from 'react';
import Airport from './components/Airport';
import NewAirport from './components/NewAirport';

const App = () => {
    return (
        <div>
            {/* <Airport /> */}
            <NewAirport />
        </div>
    );
};

export default App;
